import { render, staticRenderFns } from "./SavedImportantData.vue?vue&type=template&id=19c17db4&scoped=true&"
import script from "./SavedImportantData.vue?vue&type=script&lang=js&"
export * from "./SavedImportantData.vue?vue&type=script&lang=js&"
import style0 from "./SavedImportantData.vue?vue&type=style&index=0&id=19c17db4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c17db4",
  null
  
)

export default component.exports